module.exports = __webpack_public_path__ + "img/EG_ISRM_2023.eec5daea.png";